<script lang="ts">
  import { navigate } from 'svelte-routing'
  import { login, fetchMe } from '$lib/auth/login-flow'
  import { setSession } from '$lib/auth/session'
  import { showError } from '$lib/util/errors'
  import FormField from '../components/FormField.svelte'

  let email = $state('')
  let password = $state('')
  let submitting = $state(false)

  async function handleSubmit(e: SubmitEvent): Promise<void> {
    e.preventDefault()
    submitting = true
    try {
      const token = await login(email, password)
      const me = await fetchMe(token)
      setSession(token, me)
      navigate('/admin', { replace: true })
    } catch (err) {
      const raw = err instanceof Error ? err.message : ''
      // Backend detail codes are snake_case + short. Anything else (e.g. "Failed to fetch",
      // "NetworkError when attempting to fetch resource") is a client-side transport error -
      // don't leak the raw browser message; render our generic network-failure copy.
      const isBackendCode = /^[a-z_]+$/.test(raw) && raw.length < 60
      const detail = isBackendCode ? raw : 'login_failed'
      showError({ detail })
    } finally {
      submitting = false
    }
  }
</script>

<div class="login-shell">
  <form class="login-card" onsubmit={handleSubmit}>
    <h1>RentReadyPet</h1>
    <p class="subtitle">Admin sign in</p>
    <FormField label="Email" name="email" type="email" bind:value={email} required />
    <FormField label="Password" name="password" type="password" bind:value={password} required />
    <button type="submit" disabled={submitting || !email.trim() || !password}>
      {submitting ? 'Signing in…' : 'Sign in'}
    </button>
  </form>
</div>

<style>
  .login-shell {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: var(--surface-3);
  }
  .login-card {
    background: var(--surface-2);
    padding: 32px;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 380px;
  }
  h1 {
    margin: 0 0 4px;
    font-size: 1.5rem;
  }
  .subtitle {
    margin: 0 0 20px;
    color: var(--muted);
  }
  button {
    width: 100%;
    padding: 10px;
    min-height: 44px; /* comfortable touch target */
    background: var(--brand);
    color: white;
    border: none;
    border-radius: 4px;
    font-weight: 500;
    cursor: pointer;
  }
  button:hover:not(:disabled) {
    background: var(--brand-hover);
  }
  button:disabled {
    background: color-mix(in srgb, var(--brand) 40%, var(--surface-2));
    cursor: not-allowed;
  }
</style>
